import { gql, useMutation } from '@apollo/client'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'

export const useOtpVerify = ({ onSuccess, onError, activate = false }: any) => {
  const form = useForm({
    defaultValues: {
      otp: '',
      token: ''
    }
  })

  // auth mutation here
  const [verify, { loading }] = useMutation(VERIFY_OTP)

  const onSubmit = useCallback(
    async (data) => {
      try {
        const response = await verify({ variables: { ...data, activate } })
        onSuccess(response)
      } catch (err) {
        form.setError('otp', { message: err.message })
        onError()
      }
    },
    [verify, onSuccess, onError, form]
  )

  return {
    ...form,
    onSubmit,
    submitting: loading
  }
}

const VERIFY_OTP = gql`
  mutation verifyOtp($otp: String!, $token: String!, $activate: Boolean) {
    verifyOtp(otp: $otp, token: $token, activate: $activate) {
      message
      redirect
    }
  }
`
